"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onPreRouteUpdate = exports.onPrefetchPathname = exports.shouldUpdateScroll = exports.onRouteUpdate = exports.replaceHydrateFunction = void 0;
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
const react_1 = __importDefault(require("react"));
const client_1 = require("react-dom/client");
const prefetcher_1 = require("../components/filter/prefetcher");
const replaceHydrateFunction = () => {
    return (element, container) => {
        const store = (0, prefetcher_1.createPrefetch)();
        if (process.env.NODE_ENV === "development") {
            const root = (0, client_1.createRoot)(container);
            root.render(react_1.default.createElement(prefetcher_1.Prefetch, { provider: store }, element));
        }
        else {
            const root = (0, client_1.hydrateRoot)(container, (react_1.default.createElement(prefetcher_1.Prefetch, { provider: store }, element)));
        }
    };
};
exports.replaceHydrateFunction = replaceHydrateFunction;
const onRouteUpdate = ({ location, prevLocation }) => {
    // find if we've got a hash defined - if we do - scroll to it
    const hash = window.gatsby_router_hash;
    const scrollTo = () => {
        const scrollOffset = -100;
        const elementToScrollTo = document.getElementById(hash.substr(1));
        if (elementToScrollTo) {
            const top = elementToScrollTo.getBoundingClientRect().top + window.scrollY + scrollOffset;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    };
    if (hash) {
        if (prevLocation?.pathname === location.pathname) {
            // Don't wait for transition if page is the same
            scrollTo();
        }
        else {
            setTimeout(() => {
                scrollTo();
            }, 300); // length of Framer exit transition
        }
        window.gatsby_router_hash = undefined;
    }
    else {
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100); // length of Framer exit transition
    }
};
exports.onRouteUpdate = onRouteUpdate;
/*
* If the pathnames are the same, and there is a router hash, don't use in-built page scroll updating
* */
const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => !(prevRouterProps?.location?.pathname
    === routerProps?.location?.pathname && window.gatsby_router_hash);
exports.shouldUpdateScroll = shouldUpdateScroll;
const fetchRunner = (pathname, callback = null) => {
    if (process.env.NODE_ENV === "production" && pathname) {
        const requestedPath = pathname.split("?")[0].split("/").filter(x => !!x).join("/");
        fetch(`/__qstore/${requestedPath ? `${requestedPath}/` : ""}index.json`)
            .then((res) => {
            if (res.ok) {
                return res.json();
            }
            else if (callback) {
                callback();
            }
        })
            .then(provider => {
            if (provider) {
                Object.entries(provider.fulfilledQueries).forEach(([hash, data]) => {
                    const queryArgs = provider.queries[hash];
                    prefetcher_1.queryClient.setQueryData([JSON.stringify(queryArgs)], {
                        pageParams: [1],
                        pages: [data]
                    });
                });
                Object.entries(provider.fulfilledDependents).forEach(([id, data]) => {
                    prefetcher_1.queryClient.setQueryData(['scoped-id', id], data);
                });
                if (callback) {
                    callback();
                }
            }
        });
    }
};
const onPrefetchPathname = ({ pathname }) => {
    fetchRunner(pathname);
};
exports.onPrefetchPathname = onPrefetchPathname;
const onPreRouteUpdate = ({ location, prevLocation }) => {
    fetchRunner(location.pathname);
};
exports.onPreRouteUpdate = onPreRouteUpdate;
//# sourceMappingURL=browser.js.map